import { CONTACT } from "./data";
import { Mail, Phone, MapPin, Heart } from "lucide-react";

export const Footer = () => (
  <footer className="bg-brand-bluehover text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <img src="/logo-full-white.png" alt="Aid in Clean" className="h-16 w-auto" />
          <p className="mt-5 text-white/70 leading-relaxed max-w-xs flex items-start gap-2">
            <Heart className="h-4 w-4 mt-1 text-brand-green shrink-0" aria-hidden="true" />
            Cleaning with heart — caring for homes, workplaces and the people in them, right across Australia.
          </p>
        </div>
        <div>
          <h2 className="text-sm uppercase tracking-wide text-white/60 font-bold">Contact</h2>
          <ul className="mt-5 space-y-3">
            <li><a href={CONTACT.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 text-white/85 hover:text-brand-green transition-colors"><Phone className="h-4 w-4 text-brand-green" strokeWidth={2} aria-hidden="true" /> {CONTACT.phone}</a></li>
            <li><a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex items-center gap-3 text-white/85 hover:text-brand-green transition-colors"><Mail className="h-4 w-4 text-brand-green" strokeWidth={2} aria-hidden="true" /> {CONTACT.email}</a></li>
            <li className="flex items-center gap-3 text-white/85"><MapPin className="h-4 w-4 text-brand-green" strokeWidth={2} aria-hidden="true" /> {CONTACT.area}</li>
          </ul>
        </div>
        <div>
          <h2 className="text-sm uppercase tracking-wide text-white/60 font-bold">Services</h2>
          <ul className="mt-5 space-y-3 text-white/85">
            <li>Residential cleaning</li>
            <li>Commercial &amp; office</li>
            <li>End of lease, carpet &amp; deep clean</li>
            <li>Vehicle detailing</li>
          </ul>
          <a href="/admin" data-testid="footer-admin-link" className="mt-5 inline-block text-sm font-semibold text-white/60 hover:text-brand-green transition-colors">Admin login</a>
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-white/15 flex flex-col md:flex-row justify-between gap-4 text-sm text-white/60">
        <span>© {new Date().getFullYear()} Aid in Clean — aidinclean.com.au</span>
        <span>Fully insured • Police-checked • WCAG 2.1 AA accessible</span>
      </div>
    </div>
  </footer>
);
